<template>
  <!-- Hero -->
  <section class="bg-mainBlue">
    <div class="u-container">
      <div class="bg-white rounded-xl px-6 py-8 xl:py-10 xl:px-20">

        <!-- =======================
        === SERVICIO SHOPPER (ID 2)
        ======================== -->
        <article
          :class="typeService === 2 ? 'grid' : 'hidden'"
          class="xl:grid-cols-2 gap-20"
        >
          <div class="">
            <header
              class="bg-gray-200 xl:bg-white p-4 xl:p-0 rounded-full ring ring-gray-100 xl:ring-transparent flex gap-6 justify-around xl:justify-start mb-6 font-semibold text-xs xl:text-base relative underline"
            >
              <a
                @click.prevent="changeServiceForm(1)"
                class="z-10 flex gap-2 item-center text-gray-400 hover:text-mainOrange transition-colors cursor-pointer"
              >
                <img
                  src="../../assets/icons/SERVICIO-COURIER-1.png"
                  class="hidden xl:block w-6 h-6"
                />
                Servicio Courier
              </a>

              <a
                class="z-10 flex gap-2 item-center text-mainOrange hover:text-mainOrange transition-colors cursor-pointer"
              >
                <img
                  src="../../assets/icons/SERVICIO-SHOPPER-2.png"
                  class="hidden xl:block w-6 h-6"
                />
                Servicio Shopper
              </a>

              <div class="absolute w-1/2 rounded-full top-0 bottom-0 right-0 border border-mainOrange xl:hidden transition-all bg-white"></div>
            </header>



            <h2 class="text-bg-black-blue mb-6 text-xl xl:text-4xl font-bold">
              Sendi Shopper compra por ti en EE.UU. y lo trae a Perú
            </h2>

            <p class="mb-8 text-sm xl:text-base">
              Importa sin tarjeta internacional y sin complicaciones.
              Envíanos el link del producto y nosotros nos encargamos de comprarlo, traerlo a Perú y entregártelo.
              <br />
              <strong>Precio final transparente antes de pagar.</strong>
            </p>

            <label class="font-semibold text-xs xl:text-sm block mb-1"
              >Pega aquí el link del producto o escribe su nombre</label
            >

            <form>
              <div class="relative mb-8">
                <img
                  src="../../assets/icons/icon-search-orange.png"
                  class="absolute left-6 bottom-4 cursor-pointer"
                />
                <input
                  type="text"
                  :class="shooper.error ? 'ring ring-mainRed' : ''"
                  v-model="shooper.name"
                  placeholder="Ejemplo: “https://www.amazon.com/…” o “MacBook Pro 14 M3”"
                  class="text-textColor py-4 pl-16 px-8 rounded-xl w-full border bg-gray-100 bg-opacity-50 focus:outline-none focus:ring focus:ring-mainOrange"
                />
              </div>
              <ul class="mb-4 text-xs xl:text-sm text-gray-700 space-y-1">
                <li>✔ Nosotros compramos por ti</li>
                <li>✔ Precio final claro antes de pagar</li>
                <li>✔ Seguimiento online en tiempo real</li>
                <li>✔ Entrega en Lima o a domicilio</li>
              </ul>
              <button
                @click.prevent="searchProduct"
                class="font-semibold block w-full xl:w-1/2 rounded-xl py-4 bg-mainGreenLight text-white"
              >
                COTIZAR GRATIS
              </button>

              <p class="mt-4 text-xs xl:text-sm text-gray-600 text-left">
                Te mostraremos un estimado del costo final. Sin compromiso.
              </p>

              
            </form>
          </div>

          <img src="../../assets/images/2-sendi.png" class="ml-auto hidden xl:block" />
        </article>

        <!-- =======================
        === SERVICIO COURIER (ID 1)
        ======================== -->
        <article
          :class="typeService === 1 ? 'grid' : 'hidden'"
          class="xl:grid-cols-2 gap-20"
        >
          <div class="">
            <header
              class="bg-gray-200 xl:bg-white p-4 xl:p-0 rounded-full ring ring-gray-100 xl:ring-transparent flex gap-6 justify-around xl:justify-start mb-6 font-semibold text-xs xl:text-base relative underline"
            >
              <a
                class="z-10 flex gap-2 item-center text-mainOrange hover:text-mainOrange transition-colors cursor-pointer"
              >
                <img
                  src="../../assets/icons/SERVICIO-COURIER-1.png"
                  class="hidden xl:block w-6 h-6"
                />
                Servicio Courier
              </a>

              <a
                @click.prevent="changeServiceForm(2)"
                class="z-10 flex gap-2 item-center text-gray-400 hover:text-mainOrange transition-colors cursor-pointer"
              >
                <img
                  src="../../assets/icons/SERVICIO-SHOPPER-2.png"
                  class="hidden xl:block w-6 h-6"
                />
                Servicio Shopper
              </a>

              <div class="absolute w-1/2 rounded-full top-0 bottom-0 left-0 border border-mainOrange xl:hidden transition-all bg-white"></div>
            </header>

            <!-- TITULO NUEVO -->
            <h2 class="text-bg-black-blue mb-6 text-xl xl:text-4xl font-bold">
              Cotiza tu envío desde EE.UU. a Perú
            </h2>

            <!-- DESCRIPCIÓN NUEVA -->
            <p class="mb-8 text-sm xl:text-base">
              Calcula cuánto te costará importar a Perú tu producto comprado en Amazon, eBay, Walmart, Best Buy, Apple o cualquier tienda de EE.UU.
              <br />
              <strong>Sin registro. 100% gratis. Resultado instantáneo.</strong>
            </p>

            <!-- FORMULARIO -->
            <form>
              <div class="grid xl:grid-cols-2 gap-8 xl:gap-6 mb-8">
                
                <!-- PRECIO -->
                <div>
                  <label class="block mb-2 font-semibold text-xs xl:text-sm">
                    Precio del producto (USD)
                  </label>

                  <div class="relative">
                    <div class="absolute left-6 inset-y-0 flex items-center font-bold text-mainOrange">
                      <span>USD</span>
                    </div>

                    <input
                      :class="errorCourier.precio ? 'ring ring-mainRed' : ''"
                      class="pl-16 p-6 input w-full font-semibold bg-gray-100 bg-opacity-50 shadow-sm rounded-2xl"
                      type="number"
                      placeholder="0.00"
                      v-model="courier.precio"
                      @keydown="typeNumber"
                    />

                    <!-- Tooltip precio -->
                    <div
                      class="cursor-pointer absolute right-6 inset-y-0 flex items-center text-mainRed"
                    >
                      <img
                        @mouseover="popUp = true"
                        @mouseleave="popUp = false"
                        src="../../assets/icons/question-black.svg"
                      />
                      <div
                        :class="popUp ? '' : 'oculto'"
                        class="z-10 absolute -top-16 xl:-top-20 -right-14 xl:-right-32 bg-mainRed text-white text-xs xl:text-sm text-center p-4 rounded-2xl w-max"
                      >
                        Precio que aparece en la tienda (Amazon, eBay, etc.).
                        <span
                          class="absolute -bottom-7 right-10 xl:right-28 w-14 h-8 triangle bg-mainRed"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- PESO -->
                <div>
                  <label class="block mb-2 font-semibold text-xs xl:text-sm">
                    Peso estimado
                  </label>

                  <div class="relative">
                    <input
                      :class="errorCourier.peso ? 'ring ring-mainRed' : ''"
                      class="p-6 input w-full font-bold bg-gray-100 bg-opacity-50 shadow-sm rounded-2xl"
                      v-model="courier.peso"
                      type="number"
                      placeholder="0.00"
                      @keydown="typeNumber"
                    />

                    <div class="absolute right-6 inset-y-0 flex items-center font-bold">
                      <span
                        @click.prevent="changeUnit('kg')"
                        :class="courier.unidad === 'kg' ? 'text-mainOrange' : ''"
                        class="cursor-pointer px-3"
                        >kg</span
                      >
                      <span
                        @click.prevent="changeUnit('lb')"
                        :class="courier.unidad === 'lb' ? 'text-mainOrange' : ''"
                        class="cursor-pointer px-3 border-l border-r"
                        >lb</span
                      >
                      <span
                        @click.prevent="changeUnit('oz')"
                        :class="courier.unidad === 'oz' ? 'text-mainOrange' : ''"
                        class="cursor-pointer px-3 border-r"
                        >oz</span
                      >

                      <img
                        @mouseover="popUp2 = true"
                        @mouseleave="popUp2 = false"
                        src="../../assets/icons/icon-info.svg"
                        class="pl-3 cursor-pointer"
                      />

                      <!-- Tooltip peso -->
                      <div
                        :class="popUp2 ? '' : 'oculto'"
                        class="z-10 absolute -top-16 xl:-top-20 -right-14 xl:-right-32 bg-mainRed text-white text-xs xl:text-sm text-center p-4 rounded-2xl w-max"
                      >
                        Si no lo conoces, puedes estimarlo. Nuestro equipo lo ajustará después.
                        <span
                          class="absolute -bottom-7 right-10 xl:right-28 w-14 h-8 triangle bg-mainRed"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- CASILLA PAQUETE -->
              <div class="flex items-center gap-4 pl-2 mb-8">
                <input
                  type="checkbox"
                  class="cursor-pointer w-4 h-4 block"
                  id="paquete"
                  v-model="cotzacionAvanzada"
                />
                <label
                  for="paquete"
                  class="flex items-center gap-3 cursor-pointer text-sm xl:text-base font-medium tooltip no-underline"
                >
                  Estoy cotizando un paquete con varios productos
                  <img src="../../assets/icons/icon-info.svg" />
                  <span class="tooltip-box">
                    Úsalo si recibirás varios artículos en una sola caja.
                  </span>
                </label>
              </div>

              <!-- BOTÓN: su tamaño original -->
            <button
              @click.prevent="processCourier"
              class="font-semibold block w-full xl:w-1/2 rounded-xl py-4 bg-mainGreenLight text-white"
            >
              COTIZAR GRATIS
            </button>

            <!-- TEXTO DEBAJO: ancho completo, alineado a la izquierda -->
            <p class="mt-4 text-xs xl:text-sm text-gray-600 text-left w-full">
              Te mostraremos un estimado del costo final del envío. Sin compromiso.
            </p>



            </form>
          </div>

          <img src="../../assets/images/3-sendi.png" class="ml-auto hidden xl:block" />
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["typeService"],
  data() {
    return {
      cotzacionAvanzada: false,
      errorCourier: {
        peso: false,
        precio: false,
      },
      courier: {
        peso: "",
        precio: "",
        unidad: "kg",
      },
      shooper: {
        name: "",
        error: false,
      },
      popUp: false,
      popUp2: false,
    };
  },
  methods: {
    typeNumber($event) {
      const val = $event.target.value;
      if (val.includes(".")) {
        const dotIndex = val.indexOf(".");
        const diferencia = val.length - dotIndex;
        if (diferencia > 2 && $event.key !== "Backspace" && $event.key !== "Tab") {
          $event.preventDefault();
        }
      }
    },

    validateDataCourier() {
      this.styleErrorCourier();

      if (
        this.courier.peso &&
        this.courier.precio &&
        this.courier.unidad &&
        this.courier.peso != 0 &&
        this.courier.precio != 0
      ) {
        return true;
      }

      this.$store.state.alert.titulo = "Validación";
      this.$store.state.alert.description = "Ingrese los datos solicitados";
      this.$store.state.alert.estado = true;
      return false;
    },

    styleErrorCourier() {
      this.errorCourier.peso = !this.courier.peso;
      this.errorCourier.precio = !this.courier.precio;
    },

    processCourier() {
      if (this.validateDataCourier()) {
        this.$router.push({
          name: "Courier",
          params: {
            precio: this.courier.precio,
            peso: this.courier.peso,
            unidad: this.courier.unidad,
            typeCotizacion: this.cotzacionAvanzada,
          },
        });
      }
    },

    changeUnit(unit) {
      this.courier.unidad = unit;
    },

    searchProduct() {
      if (this.validateNameShooper()) {
        this.$router.push({
          name: "SearchShooper",
          params: { name: this.shooper.name },
        });
      }
    },

    validateNameShooper() {
      const ok = this.shooper.name.length > 0;
      this.shooper.error = !ok;
      return ok;
    },

    changeServiceForm(id) {
      this.$emit("changeService", id);
      window.localStorage.setItem("servicio", id);
    },
  },

  watch: {
    "shooper.name"() {
      this.shooper.error = false;
    },
    "courier.precio"() {
      this.errorCourier.precio = false;
    },
    "courier.peso"() {
      this.errorCourier.peso = false;
    },
  },
};
</script>
